module.exports = __webpack_public_path__ + "img/shan.99820650.jpg";